import { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { getMembers } from "../api/members";
import SearchIcon from "./icons/SearchIcon";

import avatar from "../assets/images/none_profile.png";

import MemberDetailModal from "./MemberDetailModal";
import { BASE_URL } from "../api/client";
import Skeleton from '@mui/material/Skeleton';


const MembersContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* min-width: 375px; */
  margin-top: ${(props) => (props.$isMobile ? "10px" : "120px")};
  /* padding: ${(props) => (props.$isMobile ? "0 20px" : "0")}; */
`;

const SubTitleContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.$isMobile ? "column" : "row")};
  align-items: ${(props) => (props.$isMobile ? "flex-start" : "center")};
  justify-content: ${(props) => (props.$isMobile ? "flex-start" : "space-between")};
  gap: ${(props) => (props.$isMobile ? "30px" : "0")};
  position: relative;
  color: var(--primary-c);
  animation: fadeInDown 1.5s forwards;
  margin-bottom: ${(props) => (props.$isMobile ? "30px" : "60px")};

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
 
  h3 {  
    font-size: ${(props) => (props.$isMobile ? "18px" : "22px")};
    font-weight: 700;
  }

  span {
    font-size:3rem;
  }

  ::before {
    position: absolute;
    left: 0px;
    bottom: calc(100% + 10px);
    content: "";
    display: block;
    width: ${(props) => (props.$isMobile ? "25px" : "40px")};
    height: ${(props) => (props.$isMobile ? "3px" : "5px")};
    background-color: #5293BB;
  }
`;

const SearchBox = styled.form`
  width: ${(props) => (props.$isMobile ? "100%" : "343px")};
  height: ${(props) => (props.$isMobile ? "36px" : "40px")};
  border: 1px solid var(--border-c);
  border-radius: 20px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  >input{
    width: 100%;
    height: 100%;
    font-size: ${(props) => (props.$isMobile ? "13px" : "14px")};
    outline: none;
    border: none;
  }
`;

const SearchButton = styled.button` 
  width: 20px;
  height: 100%;
  
  >svg {
    width: 100%;
    height: 100%;
  }

`;

const MemberListContainer = styled.div`
  display: flex;
  /* justify-content: ${(props) => (props.$isMobile ? "space-between" : "flex-start")}; */
  justify-content: flex-start;
  flex-wrap: wrap;
  animation: fadeInDown 1.5s forwards;
  /* gap: ${(props) => (props.$isMobile ? "32px 8px" : "60px 24px")}; */
  gap: 50px 25.5px;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-40px);
    }
    to {
      opacity: 1;
    transform: translateX(0);
    }
  }

  @media (max-width: 440px) {
    justify-content: space-between;
    gap: 32px 8px;
  }
`;

const MemberItemWrapper = styled.div`
  width: 343px;
  height: 200px;
  padding: 33px 30px;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  background-color: #F5F5F5;
  transition: all 0.3s ease;
  position: relative;

  >img{
    width: 100px;
    height: 100px;
    object-fit: cover;
    object-position: top;
    border-radius: 50%;
    margin-top: 38px;
  }

  &:hover {
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }

`;

const MemberDetailButton = styled.button`
  position: absolute;
  bottom: 8px;
  right: 9px;
  background-color: #E07A4B;
  width: 37px;
  height: 37px;
  border-radius: 12px;
  z-index: 10;
  opacity: ${(props) => (props.$forceVisible ? 1 : props.$isVisible ? 1 : 0)};
  visibility: ${(props) => (props.$forceVisible ? "visible" : props.$isVisible ? "visible" : "hidden")};
  transition: opacity 0.3s ease, visibility 0.3s ease;
  pointer-events: ${(props) => (props.$forceVisible ? "auto" : props.$isVisible ? "auto" : "none")};

  >svg {
    width: 17px;
    height: 17px;
  }
`;

// const MemberItemImageBox = styled.div`
//   position: relative;
//   max-height: 360px;
//  `;

// const MemberItemImageWrapper = styled.div`
//   padding: 67.35% 0;


//   img{
//     -o-object-fit: cover;
//     object-fit: cover;
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     -webkit-transform: translate(-50%, -50%);
//     transform: translate(-50%, -50%); 
//     width: 100%;
//     height: 100%;
//     max-width: 250px;
//     overflow: hidden
//   }
//   `;

// const MemberDetailButton = styled.button`
//   position: absolute;
//   bottom: -10px;
//   right: 0;
//   background-color: #bfbfbf;
//   width: 90px;
//   height: 90px;
//   border-radius: 50%;
//   z-index: 10;
//   padding: 25px 23px 24px 26px;
//   transition: all 0.3s ease;

//   @media  (max-width: 1280px) {
//     width: 70px;
//     height: 70px;
//     padding: 20px 18px 19px 22px;
//   }

//   >svg {
//     width: 100%;
//     height: 100%;
//   }

//   &:hover {
//     background-color: #0089b3;
//     box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);
//   }
// `;

const MemberInfoBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  `;

const MemberInfoTopBox = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

const MemberInfoBoxName = styled.h4`
  font-size: 18px;
  font-weight: 700;
  `;

const MemberInfoBoxRole = styled.div`
  height: 100%;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: flex-end; 
  justify-content: center;
  gap: 6px;
  color: var(--primary-c);
`;

const RoleItem = styled.span`
  display: block;
`;

const RoleDivider = styled.span`
  display: block;
  margin: 1px 0;
`;

const MemberCareerBox = styled.div`
  width: 100%;
  /* height: 50%; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 6px;
`;

const MemberCareerBoxTitle = styled.h5`
  font-size: 13px;
  font-weight: 600;
`;

const MemberCareerBoxContent = styled.p`
  width: 100%;
  height: 100%;
  font-size: 12px;
  line-height: 1.3;
  word-spacing: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
`;

const MemberListSection = ({
  activeMenu,
  isMobile = false,
  showTitle = true,
  showSearch = true,
  titleOverride,
  DetailModalComponent = MemberDetailModal,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [members, setMembers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [hasMemberList, setHasMemberList] = useState(false);
  const [hoveredMemberId, setHoveredMemberId] = useState(null);

  const fetchMembers = useCallback(async (name) => {
    setIsLoading(true);
    const data = await getMembers(activeMenu, name);
    const { members } = data;
    const serialMembers = members.map((member, index) => {
      const { createdAt, ...rest } = member;
      return {
        ...rest,
      };
    });
    setMembers(serialMembers);
    setHasMemberList(serialMembers.length > 0);
    setIsLoading(false);
  }, [setMembers, activeMenu]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const name = formData.get("name");
    if (name.trim() === "") {
      fetchMembers();
    } else {
      fetchMembers(name);
    }
  }

  useEffect(() => {
    fetchMembers();
  }, [fetchMembers, activeMenu]);

  return (
    <>
      <MembersContainer $isMobile={isMobile}>
        {(showTitle || showSearch) && (
          <SubTitleContainer $isMobile={isMobile}>
            {showTitle && <h3>{titleOverride || activeMenu}</h3>}
            {showSearch && (
              <SearchBox onSubmit={handleSearchSubmit} $isMobile={isMobile}>
                <input type="text" placeholder="이름 검색" name="name" />
                <SearchButton type="submit">
                  <SearchIcon />
                </SearchButton>
              </SearchBox>
            )}
          </SubTitleContainer>
        )}
        {!isLoading ? (
          hasMemberList && (
            <MemberListContainer $isMobile={isMobile}>
              {members.map((member, index) => (
                <MemberItemWrapper
                  key={member.id}
                  no={index + 1}
                  $isMobile={isMobile}
                  onClick={() => {
                    setSelectedMemberId(member.id);
                    setIsModalOpen(true);
                  }}
                  onMouseEnter={() => {
                    setHoveredMemberId(member.id);
                  }}
                  onMouseLeave={() => {
                    setHoveredMemberId(null);
                  }}
                >
                  <MemberDetailButton
                    $isVisible={hoveredMemberId === member.id}
                    $forceVisible={false}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedMemberId(member.id);
                      setIsModalOpen(true);
                    }}
                  >
                    <SearchIcon color="#fff" />
                  </MemberDetailButton>
                  {/* {member.profile ? (
                    <img
                      src={`${BASE_URL}/image/${member.profile}`}
                      alt={member.name}
                    />
                  ) : (
                    <img src={avatar} alt={member.name} />
                  )} */}
                  <MemberInfoBox>
                    <MemberInfoTopBox>
                      <MemberInfoBoxName>{member.name}</MemberInfoBoxName>
                      <MemberInfoBoxRole>
                        {member.role && member.role.split('/').map((role, index, array) => {
                          const trimmedRole = role.trim();
                          if (!trimmedRole) return null;

                          return (
                            <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
                              <RoleItem>{trimmedRole}</RoleItem>
                            </div>
                          );
                        })}
                      </MemberInfoBoxRole>
                    </MemberInfoTopBox>
                    <MemberCareerBox>
                      <MemberCareerBoxTitle>경력</MemberCareerBoxTitle>
                      <MemberCareerBoxContent>{member.career}</MemberCareerBoxContent>
                    </MemberCareerBox>
                  </MemberInfoBox>
                  {/* <MemberItemImageBox onClick={() => {
                    setSelectedMemberId(member.id);
                    setIsModalOpen(true);
                  }}>
                    <MemberItemImageWrapper>
                      {member.profile ? (
                        <img
                          src={`${BASE_URL}/image/${member.profile}`}
                          alt={member.name}
                        />
                      ) : (
                        <img src={avatar} alt={member.name} />
                      )}
                    </MemberItemImageWrapper>
                    <MemberDetailButton
                      onClick={() => {
                        setSelectedMemberId(member.id);
                        setIsModalOpen(true);
                      }}
                    >
                      <SearchIcon />
                    </MemberDetailButton>
                  </MemberItemImageBox> */}
                  {/* <MemberInfoContainer>
                    <MemberInfoBox>
                      <MemberInfoBoxRole>{member.role}</MemberInfoBoxRole>
                      <MemberInfoBoxName>{member.name}</MemberInfoBoxName>
                    </MemberInfoBox>
                  </MemberInfoContainer> */}
                </MemberItemWrapper>
              ))}
            </MemberListContainer>
          )
        ) : (
          <MemberListContainer>
            {Array.from(new Array(6)).map((_, index) => (
              <Skeleton key={index} variant="rectangular" width={343} height={200} sx={{ borderRadius: '12px' }} />
            ))}
          </MemberListContainer>
        )}
        {isModalOpen && (
          <DetailModalComponent
            onClose={() => {
              setIsModalOpen(false);
              setSelectedMemberId(null);
            }}
            memberId={selectedMemberId}
          />
        )}
      </MembersContainer>
    </>

  )
}

export default MemberListSection;